import React from 'react';
import Carousel from '../ui/Carousel';
import homepage from '../../cms/homepage.json';

const electionsHighlight = homepage.electionsHighlight || {};

const ElectionsHighlight = () => {
  if (!electionsHighlight?.enabled || !electionsHighlight?.images?.length) return null;

  return (
    <section className="elections-highlight-section" data-aos="fade-up">
      <div className="elections-highlight-header">
        <h2 className="section-title">{electionsHighlight.title}</h2>
        {electionsHighlight.subtitle && (
          <p className="section-subtitle">{electionsHighlight.subtitle}</p>
        )}
      </div>

      <Carousel
        className="elections-highlight-carousel"
        items={electionsHighlight.images}
        itemsPerView={3}
        showDots={false}
        renderItem={(item) => (
          <div className="election-photo-card">
            {item.url ? (
              <a href={item.url} target="_blank" rel="noopener noreferrer">
                <img src={item.src} alt={item.alt || ''} className="election-photo" />
              </a>
            ) : (
              <img src={item.src} alt={item.alt || ''} className="election-photo" />
            )}
          </div>
        )}
      />
    </section>
  );
};

export default ElectionsHighlight;


